module.exports = __webpack_public_path__ + "assets/ebike_light.0f642b30.svg";